export const ProductTypes = {
  ADD_PRODUCT_QUANTITY: "ADD_PRODUCT_QUANTITY",
  DECREASE_PRODUCT_QUANTITY: "DECREASE_PRODUCT_QUANTITY",
  ADD_PRODUCT_CART: "ADD_PRODUCT_CART",
  REMOVE_PRODUCT_CART: "REMOVE_PRODUCT_CART",
};
